import translate from '@data/translations';

export const getHWIconDescriptor = (dashboardObj, inputName, alarmInterpreter) => {
    const inputs = alarmInterpreter?.inputInterpreter
        ? alarmInterpreter.inputInterpreter.filter((i) => i.enabled)
        : [];
    const inputMap = {};
    inputs.forEach((i) => {
        inputMap[i.name] = i;
    });

    const desc = inputMap[inputName];
    if (!desc || !desc.enabled) {
        return null;
    }

    const isInputClosed = dashboardObj.inputs[inputName] === 0; //inputi su zatvoreni ako postoji i ako je false!!!
    const isSpecialAlarmInput = inputName === 'floodAlarmInput' || inputName === 'cardHolderInput';

    //specijalni inputi (flood, cardHolder) - alarm se pali na true state; ostali - alarm se pali na false state
    const iconClass = isSpecialAlarmInput
        ? isInputClosed
            ? `${desc.icon} ${desc.falseStateAnimationBlink === 'true' ? ' animated infinite flash ' : ''}`
            : `${desc.icon} ${desc.trueStateAnimationBlink === 'true' ? ' animated infinite flash ' : ''}`
        : !isInputClosed
        ? `${desc.icon} ${desc.falseStateAnimationBlink === 'true' ? ' animated infinite flash ' : ''}`
        : desc.icon;

    const color = isSpecialAlarmInput
        ? isInputClosed
            ? desc.falseStateIconColor
            : desc.trueStateIconColor
        : !isInputClosed
        ? desc.falseStateIconColor
        : desc.trueStateIconColor;

    return { iconClass, color, title: translate(inputName) };
};

export default getHWIconDescriptor;
